import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';

@Injectable({
  providedIn: 'root'
})
export class MyDocApprovalsService {

  constructor(private httpClient: HttpClient) { }

  getMyDocApprovals(includeAll: boolean): Observable<DocumentSearchResult[]> {
    return this.httpClient.get<DocumentSearchResult[]>(ApiConstants.DocumentMyApprovals_Api+"/"+includeAll);
  }
}
